export default "__VITE_PUBLIC_ASSET__51f5aefe__"